<template>
<div class="user-edit">
  <el-form ref="editForm" label-width="100px" :model="editJson" :rules="rules">
    <el-form-item label="部门名称" prop="departmentNo" v-if="isEdit">
      <common-select :disabled="isEdit" v-model="editJson.departmentNo" :url="$api.Identity.Categord.dep" ajaxMethod="get" optLabel="displayName" optValue="code" @loadDataSuccess="resDepData"></common-select>
    </el-form-item>
    <el-form-item label="姓名" prop="wkNo">
       <selecter :disabled="isEdit" v-model="editJson.wkNo" :url="$api.sys.userInfo.downList" @selecterData="getSelecterWkNameData" :jobNo="editJson.wkNo" :name="editJson.wkName" isAll></selecter>
    </el-form-item>
    <el-form-item label="上级姓名" prop="superiorNo">
       <selecter v-model="editJson.superiorNo" :appendBody="false" ajaxMethod="get" :url="$api.sys.users.list" :paramsReset="paramsResetFn" :formatData="formatDataFn" @selecterData="getSelecterSuperioerWkNameData" :jobNo="editJson.superiorNo" :name="editJson.superiorName" isAll></selecter>
    </el-form-item>
    <el-form-item label="不参评原因" prop="noOecReason">
      <el-input type="textarea" v-model="editJson.noOecReason" placeholder="不参评原因"></el-input>
    </el-form-item>
    <el-form-item label="离职时间" prop="dimissionTime">
      <el-date-picker v-model="editJson.dimissionTime" type="date" placeholder="离职时间">
    </el-date-picker>
    </el-form-item>
   <el-form-item label="是否离职" prop="isDismision">
      <el-switch v-model="editJson.isDismision" :inactive-value="0" :active-value="1"></el-switch>
      &nbsp;&nbsp;{{ editJson.isDismision == 1 ? "是": '否' }}
    </el-form-item>
    <el-form-item label="是否OEC" prop="isOEC">
      <el-switch v-model="editJson.isOEC" :inactive-value="0" :active-value="1"></el-switch>
      &nbsp;&nbsp;{{ editJson.isOEC == 1 ? "是": '否' }}
    </el-form-item>
    <el-form-item label-width="0" class="atb-no-margin">
        <div class="atb-text-right">
        <!-- 保存 -->
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
        <!-- 取消 -->
        <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
        </div>
  </el-form-item>
  </el-form>
</div>

</template>
<script>
import editMixin from '@/mixins/edit.mixin'
import XEUtils from 'xe-utils'
import _ from 'lodash';
export default {
  components: {
    selecter:()=>import('@/component/global/customerSelect')
  },
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      id: 'id',
      rules: {
        wkNo: [
          { required: true, message: '姓名必填', trigger: 'change' }
        ]
      },
      addApi: this.$api.sys.users.adu,
      editApi: this.$api.sys.users.adu,
      addMethod:'post',
      editMethod:'put',
      depData:[],
      seleterWkNameData:[],
      seleterSuperioerWkNameData:[]
    }
  },
  mounted(){
      if(!this.isEdit){
        this.$set(this.editJson,"isOEC",1);
      }
      this.$set(this.editJson,"noOecReason",this.editData.noOecReason);
  },
  methods:{
     resetSubmitParams(params){
       const sendParams={};
       sendParams.id=params.id;
       sendParams.wkName=params.wkNo? this.seleterWkNameData.find(t=>t.jobNo==params.wkNo).name: '';
       sendParams.superioerWkName=params.superiorNo? this.seleterSuperioerWkNameData.find(t=>t.jobNo==params.superiorNo).name: '';
       sendParams.wkNo=params.wkNo;
       sendParams.superioerWkNo=params.superiorNo;
       sendParams.noOecReason=params.noOecReason;
       sendParams.dimissionTime=this.formatDate(params.dimissionTime, 'yyyy-MM-dd');
       sendParams.isDismision=params.isDismision;
       sendParams.isOEC=params.isOEC;
       return sendParams;
     },
     resDepData(data){
        this.depData=data;
     },
     getSelecterWkNameData(data){
        this.seleterWkNameData=data;
     },
     getSelecterSuperioerWkNameData(data){
        this.seleterSuperioerWkNameData=data;
     },
     paramsResetFn(query, pageIndex, pageSize){
       return { filter: query, PageIndex: pageIndex, PageSize: pageSize }
     },
     formatDataFn(res){
       const list=[];
       const obj={};
       res.data&&res.data.rows.forEach(t=>{
          const _obj= _.cloneDeep(obj);
          _obj.department=t.department
          _obj.jobNo=t.wkNo,
          _obj.name=t.wkName
          list.push(_obj);
       });
       return list;
     },
     formatDate(value, format) {
      return XEUtils.toDateString(value, format)
     },
  }
}
</script>
<style scoped lang='scss'>
.user-edit{
    .customerSelect{
      width: 100%;
    }
    .el-date-editor--date{
      width: 100%;
    }
}
</style>